var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "currentColor",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2287_52)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14.2648,
    r: 6.35294,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20.6177V29.0883",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4013 11.9402C15.4013 11.664 15.6252 11.4402 15.9013 11.4402H20.0447C20.3209 11.4402 20.5447 11.664 20.5447 11.9402C20.5447 12.2163 20.3209 12.4402 20.0447 12.4402H18.9844C19.1244 12.6484 19.2317 12.8809 19.2993 13.1296H20.0447C20.3209 13.1296 20.5447 13.3534 20.5447 13.6296C20.5447 13.9057 20.3209 14.1296 20.0447 14.1296H19.3491C19.2667 14.6009 19.0303 14.9901 18.6802 15.2708C18.2896 15.584 17.7896 15.7376 17.273 15.7618L19.2418 17.4109C19.4534 17.5883 19.4813 17.9036 19.304 18.1153C19.1266 18.327 18.8113 18.3548 18.5996 18.1775L15.5805 15.6485C15.4193 15.5134 15.3598 15.292 15.4316 15.0944C15.5035 14.8967 15.6913 14.7652 15.9015 14.7652H17.1266C17.5279 14.7652 17.847 14.6571 18.0547 14.4906C18.1682 14.3995 18.2606 14.282 18.3178 14.1296H15.9013C15.6252 14.1296 15.4013 13.9057 15.4013 13.6296C15.4013 13.3534 15.6252 13.1296 15.9013 13.1296H18.2332C18.0193 12.7154 17.5979 12.4403 17.1266 12.4403C17.122 12.4403 17.1174 12.4403 17.1128 12.4402H15.9013C15.6252 12.4402 15.4013 12.2163 15.4013 11.9402Z",
    fill: "#D90368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4533 25.5666L14.1001 24.2586M10.3654 24.3168L14.1001 24.2586M14.1001 24.2586C12.5338 16.084 4.43877 25.4081 6.64682 25.0808C8.85486 24.7534 11.0199 28.719 13.7347 26.3306",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5468 25.5666L21.9 24.2586M25.6347 24.3168L21.9 24.2586M21.9 24.2586C23.4662 16.084 31.5613 25.4081 29.3532 25.0808C27.1452 24.7534 24.9801 28.719 22.2653 26.3306",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2287_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.4118,
    height: 24,
    fill: "white",
    transform: "translate(5.29413 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMf);
export default __webpack_public_path__ + "static/media/mf.4ce3cf4a1cb65cd60d3ecbdffa7dd568.svg";
export { ForwardRef as ReactComponent };